export default __webpack_public_path__ + "static/international-yards-mobile-68bd7d7fb8a2660959a3d1bd5a0378a5.svg";